export class PagerDataObject {
  entity: any;
  total: number;
  records: any;
  from: number;
  to: number;
  totalSum?: any[];
}
